import { InjectionToken } from '@angular/core';
import { PaymentFlexConfig } from '../models/payment-flex/payment-flex-config.interface';

export const PAYMENT_FLEX_CONFIG = new InjectionToken<PaymentFlexConfig>(
  'Payment Flex Payment Config'
);
